export const locKeys = {
  showMore: "merchCampaign.showMoreButton",
};
